import React, { FC } from "react";

import { BannerProps } from "./models";
import { Wrapper } from "./styles";

const ShareSmartBanner: FC<BannerProps> = ({ onClick }) => {
  return (
    <Wrapper>
      <p>
        Smart investors share smart deals — and <span>earn $100!</span>
      </p>
      <button type="button" onClick={onClick}>
        Share & earn
      </button>
    </Wrapper>
  );
};

export default ShareSmartBanner;
